<template>
    <LoadingCard v-if="loading" />
    <div class="content__inner content__inner--sm" v-else>
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">{{ block.name }} Details</h2>
            </div>

            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="view = 'details'" :class="{active: view === 'details'}">Details</a>
                </li>
                <li class="nav-item" v-if="!block.owner.is_processor_managed">
                    <a class="nav-link" @click.prevent="view = 'processors'" :class="{active: view === 'processors'}">Processors</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" @click.prevent="view = 'contractors'" :class="{active: view === 'contractors'}">Contractors</a>
                </li>
            </ul>
        </div>

        <component :is="viewComponent" :block="block" />
    </div>
</template>

<script>
import findBlockQuery from '@views/Blocks/Update/queryFindBlock.graphql';
import ContractorManager from './ContractorManager';

import DetailsManager from './DetailsManager';
import ProcessorManager from './ProcessorManager';

export default {
  name: 'EditBlock',
  props: ['blockId'],
  apollo: {
    block: {
      query: findBlockQuery,
      variables() {
        return {
          input: {
            id: this.blockId,
          },
        };
      },
      update: data => data.findBlock,
    },
  },
  components: {
    DetailsManager,
    ProcessorManager,
    ContractorManager,
  },
  data() {
    return {
      loading: 0,
      block: null,
      view: 'details',
      validation: {
        name: { required: true },
        variety: { required: true },
      },
    };
  },
  computed: {
    viewComponent() {
      switch (this.view) {
        case 'details':
          return DetailsManager;
        case 'processors':
          return this.block.owner.is_processor_managed ? null : ProcessorManager;
        case 'contractors':
          return ContractorManager;
      }
    },
  },
  methods: {},
};
</script>
